<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Preferred Suppliers</h1>

      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel form-group">
          <div class="ui-g-12 ui-md-4 adjustment_filter">
            <span class="md-inputfield filterItem">
              <input
                name="name"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.name.value"
              />
              <label>Name</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 adjustment_filter">
            <span class="md-inputfield filterItem">
              <input
                name="quality"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.quality.value"
              />
              <label>Quality Score</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 adjustment_filter">
            <span class="md-inputfield filterItem">
              <input
                name="status"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.status.value"
              />
              <label>Status</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 adjustment_filter">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clearFilter(dataTable)"></button>
          </div>
        </div>
      </form>

      <p-table
        #dataTable
        selectionMode="single"
        [(selection)]="selectedItem"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
        [hidden]="!isLoaded"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Quality</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr (dblclick)="showDialogToEdit(item)" [pSelectableRow]="item">
            <td>{{ item.name }}</td>
            <td>{{ item.quality }}</td>
            <td>
              <div *ngIf="item.status === 'invited'">{{ item.status }}</div>
              <div *ngIf="item.status !== 'invited'" (click)="changeStatus(item.id)">
                {{ item.status }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED --
			<p-dataTabl #dataTable selectionMode="single"  [(selection)]="selectedItem" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true"
                [paginator]="true" rowHover="true" resizableColumns="true" [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                [rowsPerPageOptions]="[5,10,20]" (onRowDblclick)="showDialogToEdit(selectedItem)" 
                [pageLinks]="3" [hidden]="!isLoaded">
				<p-column field="name" header="Name" [sortable]="true" [editable]="false"></p-column>
				<p-column field="quality" header="Quality Score" [sortable]="true" [editable]="false"></p-column>
				<p-column field="status" header="Status" [sortable]="true">
					<ng-template let-supplier="rowData" pTemplate="body">
						<div *ngIf="supplier.status === 'invited'">{{supplier.status}}</div>
						<div *ngIf="supplier.status !== 'invited'" (click)="changeStatus(supplier.id)">{{supplier.status}}</div>
					</ng-template>
				</p-column>
			</p-dataTable>

			-->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-input"
          (click)="goToImportData()"
          label="Import Data"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          (click)="showDialogToEdit(selectedItem)"
          label="Edit"
          pButton
          icon="fa ui-icon-mode-edit"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
      </div>

      <p-dialog
        header="Preferred Suppliers"
        [(visible)]="displayDialog"
        [responsive]="true"
        [modal]="true"
        [style]="{ width: '500px' }"
      >
        <form
          [formGroup]="newPreferredSupplierForm"
          (ngSubmit)="save(newPreferredSupplierForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="preferredSupplier">
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="name">Name</label></div>
              <div class="ui-g-8">
                <input pInputText id="name" formControlName="name" maxlength="100" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="addressLine1">Address line 1</label></div>
              <div class="ui-g-8">
                <input
                  pInputText
                  name="addresLine1"
                  id="addressLine1"
                  formControlName="addressLine1"
                  maxlength="35"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="addressLine2">Address line 2</label></div>
              <div class="ui-g-8">
                <input pInputText id="addressLine2" formControlName="addressLine2" maxlength="35" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4">
                <label for="addressLine2">Address line 3</label>
              </div>
              <div class="ui-g-8">
                <input pInputText id="addressLine3" formControlName="addressLine3" maxlength="35" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="town">Town</label></div>
              <div class="ui-g-8">
                <input pInputText id="town" formControlName="town" maxlength="35" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="postcode">Postcode</label></div>
              <div class="ui-g-8">
                <input pInputText id="postcode" formControlName="postcode" maxlength="8" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="emailAddress">Email address</label></div>
              <div class="ui-g-8">
                <input
                  pInputText
                  id="emailAddress"
                  formControlName="emailAddress"
                  maxlength="254"
                />
              </div>
            </div>
          </div>

          <div style="float: right">
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              [disabled]="newPreferredSupplierForm.invalid"
            ></button>
            <button
              type="button"
              pButton
              icon="fa ui-icon-close"
              label="Cancel"
              (click)="close()"
            ></button>
          </div>
        </form>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
